export const environment = {
  production: true,
  development: false,
  test: false,
  authorizeProspectBrands: '[\"VYV\", \"HM\", \"MGEN\", \"MNT\"]',
  product: 'PJ',
  brand: 'VYV',
  apiV2RootUrl: 'https://tst.assurance.vyv-conseil.fr/api/',
  baseUrl: 'https://tst.assurance-habitation.vyv-conseil.fr/',
  matomotoKey: 'CHANGEME',
  appInsightsKey: 'e9c64840-c6be-4cce-b997-91dd6be90ca1',
  assGarantie:
    'https://saboiartbackofficera6ej.blob.core.windows.net/public/VYV_Plaquette_Assurance_Protection_Juridique_Tableau%20des%20garanties.pdf',
  matomoSiteId: 6,
  matomoHostUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/',
  matomoScriptUrl: 'https://matomo-recette.vyv-extension-essai.aws.mgen.fr/js/container_682wvypB.js',
  msalConfig: {
    auth: {
      clientId: 'dbcec950-8f61-48f7-91f7-76008b2038b4',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
      redirectUri: 'https://tst.assurance-protection-juridique.vyv-conseil.fr/',
    },
  },
  apiConfig: {
    scopes: ['api://boiard-tst-back-office/Read.All', 'api://boiard-tst-back-office/Write.All'],
    uri: 'https://tst.assurance.vyv-conseil.fr/api/',
  },
  url_espace_adherent: 'https://tst.assurance.vyv-conseil.fr/mon-espace/',
  googleTagManagerId: 'GTM-M2XCS4XC'
};
